import React, { memo } from 'react';
import { Container } from '@app/components';
import { LayoutDefault } from '@app/layouts';
import { Card, CardContent } from 'components/ui/card';

interface NotFoundPageProps {}

function NotFoundPage(props: NotFoundPageProps) {
  return (
    <LayoutDefault className="p-home">
      <Container>
        <Card className="max-w-lg mx-auto my-16">
          <CardContent>
            <div className="text-center text-2xl font-bold text-muted-foreground py-12">
              This is 404 page
            </div>
          </CardContent>
        </Card>
      </Container>
    </LayoutDefault>
  );
}

export default memo(NotFoundPage);
